// extracted by mini-css-extract-plugin
export default {"cards":"styles_cards__2PGWq","card":"styles_card__s1zS+"};